/* eslint-disable @typescript-eslint/no-explicit-any */
import summaryCommonStore from "@/store/summaryCommon.store";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import ArrowLeftIcon from "@/assets/summary/arrow_left.svg";
import summarySrcStore from "@/store/summarySrc.store";
import { RuningInLink } from "@/constants";
import useCheckEditBeforeClick from "@/sections/Summary/useCheckEditBeforeClick";
import Tooltip from "@/component/Tooltip";
import { recordTitleMaxLen } from "@/constants/record";
import fridayReporter from "@/utils/friday";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import "./index.less";
import dayjs from "dayjs";
import useGetDisplayUserInfo from "@/sections/User/useGetDisplayUserInfo";
import { getUser } from "@/store/user.store";
import IcRecordSetting from "@/assets/svg/ic_setting.svg?react";
import DeviceControlModal from "../DeviceControlModal";
import deviceStore from "@/store/device.store";
import { message } from "antd";

export interface IHeaderProps {
  title?: string;
  isOnlyBack?: boolean;
  createdDate?: string;
  titleEditable?: boolean;
  showSetting?: boolean;
  // 修改标题方法
  commitTitleChange?: (title: string) => Promise<boolean>;
  handleBack?: () => void;
}

const Header: React.FC<IHeaderProps> = ({
  title,
  createdDate,
  isOnlyBack = false,
  titleEditable = false,
  showSetting = false,
  commitTitleChange,
  handleBack,
}) => {
  const navigate = useNavigate();
  const { displayUserInfo } = useGetDisplayUserInfo();
  const { displayName, identityType, companyRealName } = displayUserInfo;
  const wsConnected = deviceStore((state) => state.wsConnected);
  const deviceName = deviceStore((state) => state.deviceName);
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const initStore = summaryCommonStore((state) => state.initStore);
  const pageCreatedDate = dayjs(createdDate || undefined); // 前端显示时间

  const [deviceControlVisible, setDeviceControlVisible] = useState(false);
  // 如果有传入 title 就使用传入的，否则生成默认标题
  const [newTitle, setNewTitle] = useState(
    title || `新建同传_${pageCreatedDate.format("YYYY年MM月DD日")}`
  );
  const [titleEditing, setTitleEditing] = useState(false);
  const deviceAddress = deviceStore.getState().getDeviceAddress();
  useGetDisplayUserInfo();

  // 监听 title prop 变化，动态更新 newTitle
  useEffect(() => {
    if (title) {
      setNewTitle(title);
    }
  }, [title]);

  const formatUserName = identityType === 0 ? displayName : companyRealName;
  const [webviewUrl, setWebviewUrl] = useState<string | undefined>();

  useEffect(() => {
    getUser();
  }, []);

  const back = useCheckEditBeforeClick(() => {
    handleBack?.();
    fridayReporter.pushData({
      eventCode: "SummaryPage_ReturnHomepage",
    });
    navigate("/home");
    initStore();
  });

  const handleEditTitle = () => {
    if (!titleEditable) return;
    setTitleEditing(true);
  };

  const onTitleChange = (e: string) => {
    setNewTitle(e);
  };

  const submitTitle = async () => {
    setTitleEditing(false);
    commitTitleChange?.(newTitle);
  };

  const formatCreateTime = useMemo(() => {
    const createTime = detailInfo?.createdDate || pageCreatedDate;
    if (dayjs(createTime).year === dayjs().year) {
      return dayjs(createTime).format("MM-DD");
    }
    return dayjs(createTime).format("YY-MM-DD");
  }, [detailInfo?.createdDate, pageCreatedDate]);

  const handleRecordSetting = () => {
    if (!wsConnected) {
      message.error("设备连接已断开，无法使用该功能");
      return;
    }
    setWebviewUrl(deviceAddress ? `${deviceAddress}/control` : undefined);
    console.log("webviewUrl = ", webviewUrl);
    setDeviceControlVisible(true);
  };

  const handleCloseDeviceControl = () => {
    setDeviceControlVisible(false);
  };

  return (
    <div
      className={`h-16 px-6 py-2.25 flex items-center justify-between ${!RuningInLink && "mt-2"
        } header`}
    >
      <div className="flex items-center overflow-hidden">
        {<img className="w-6 h-6 mr-3" src={ArrowLeftIcon} onClick={back} />}
        {!isOnlyBack && (
          <div className="overflow-hidden mr-4">
            <div className="h-6">
              {titleEditing ? (
                <input
                  autoFocus
                  maxLength={recordTitleMaxLen}
                  onChange={(e) => {
                    onTitleChange(e.target.value);
                  }}
                  value={newTitle}
                  className="bg-transparent b-1 b-solid b-mx-primary text-4 focus:b-mx-primary focus-outline-none px-2 py-1.5 rounded-1 lh-4 w-68 h-6"
                  onBlur={submitTitle}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  onKeyDown={(e) => {
                    e.key === "Enter" && submitTitle();
                  }}
                />
              ) : (
                <Tooltip
                  tooltipHelper={<div className={`text-4 h-6`}>{newTitle}</div>}
                  content={newTitle}
                  onlyShowWhenOverflow
                >
                  <div
                    className={`text-4 h-6 select-text mx-text-ellipsis ${titleEditable ? "hover:cursor-pointer" : ""
                      }`}
                    onClick={handleEditTitle}
                  >
                    {newTitle}
                  </div>
                </Tooltip>
              )}
            </div>
            {
              <div className="flex items-center text-3 text-#999 h-6 lh-6">
                {formatUserName && (
                  <div className="flex items-center mr-1">
                    <SpeakerAvatar
                      className={`size-4 text-1.5`}
                      avatarIndex={0}
                      speakerName={formatUserName}
                    />
                    <div className="text-3 text-#999999 pl-1">
                      {formatUserName}
                    </div>
                  </div>
                )}
                <div className="ml-1 text-3 text-#999999">
                  {formatCreateTime ? `创建于 ${formatCreateTime}` : ""}
                </div>
              </div>
            }
          </div>
        )}
      </div>
      {showSetting && (<div className="flex items-center gap-2">
        <div className={`w-1.5 h-1.5 ${wsConnected ? "bg-#00C324" : "bg-#00000026"} rounded-full`} />
        {wsConnected ? (
          <span className="text-3.5 text-#191D26 mr-2">{`已连接 ${deviceName ? ` ${deviceName}` : ''}`}</span>
        ) : (
          <Tooltip content={"未恢复连接的情况下，超过5小时，大屏自动结束录制"}>
            <span className="text-3.5 text-#191D26 mr-2">连接已断开</span>
          </Tooltip>
        )}
        <Tooltip content="录制设置">
          <IcRecordSetting className="w-8.5 h-8.5 cursor-pointer" onClick={handleRecordSetting} />
        </Tooltip>
      </div>
      )}
      <DeviceControlModal
        visible={deviceControlVisible}
        webviewUrl={webviewUrl}
        isWsConnected={wsConnected}
        onClose={handleCloseDeviceControl}
      />
    </div>
  );
};

export default Header;
